import StoreSkeletonMcom from './StoreSkeleton.mcom';
import StoreSkeletonBcom from './StoreSkeleton.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? StoreSkeletonBcom : StoreSkeletonMcom;
